// extracted by mini-css-extract-plugin
module.exports = {"errorMessageContainer":"styles_errorMessageContainer__1qre9","header":"styles_header__3-u1Z","messageContent":"styles_messageContent__2jkXX","button":"styles_button__K5KS8"};